import { Link } from "@nextui-org/react";
import { collection, doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useAuth, useFirestore, useFirestoreDocData, useUser } from "reactfire";

export const UsageMeter = () => {
    const [currentUsage, setCurrentUsage] = useState(0);

    const auth = useAuth();
    const user = useUser();
    const firestore = useFirestore();

    useEffect(() => {
        const fetchUsageData = async () => {
            if (user) {
                try {
                    const usageRef = doc(collection(firestore, 'usage'), user.data?.uid);
                    const usageDoc = await getDoc(usageRef);
                    if (usageDoc.exists()) { 
                        const usage = usageDoc.data();
                        setCurrentUsage(usage?.dailyPages);
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }
        fetchUsageData();
    }, []);

    return (
        <>
            <div className="text-sm">Free Plan</div>
            <Link href="/user">
            <span className="text-sm">{currentUsage}/100 pages per Day</span>
            </Link>
        </>
    )

}